/**
 * SVG eye layers — extracted from the reference PREVIEW.html.
 * All coordinates target a 400×500 viewBox, matching the body canvas.
 */
import React from 'react';
import { EyesKey } from '@/config/buddyLayerMap';

interface Props {
  variant: EyesKey;
}

const EyesOpen = () => (
  <>
    {/* Eyebrows */}
    <path d="M118 158 Q138 150 158 155" stroke="#1a0a00" strokeWidth="5.5" strokeLinecap="round" fill="none"/>
    <path d="M218 155 Q238 150 255 158" stroke="#1a0a00" strokeWidth="5.5" strokeLinecap="round" fill="none"/>
    {/* Left eye */}
    <circle cx="148" cy="188" r="28" fill="#111"/>
    <circle cx="148" cy="188" r="20" fill="#1a1a1a"/>
    <ellipse cx="138" cy="178" rx="7" ry="8" fill="white" opacity="0.95"/>
    <circle cx="158" cy="196" r="3.5" fill="white" opacity="0.85"/>
    <path d="M134 174 L136 170 L138 174 L142 176 L138 178 L136 182 L134 178 L130 176 Z" fill="white"/>
    {/* Right eye */}
    <circle cx="245" cy="188" r="28" fill="#111"/>
    <circle cx="245" cy="188" r="20" fill="#1a1a1a"/>
    <ellipse cx="235" cy="178" rx="7" ry="8" fill="white" opacity="0.95"/>
    <circle cx="255" cy="196" r="3.5" fill="white" opacity="0.85"/>
  </>
);

const EyesHappy = () => (
  <>
    <path d="M115 148 Q138 138 160 145" stroke="#1a0a00" strokeWidth="5.5" strokeLinecap="round" fill="none"/>
    <path d="M216 145 Q238 138 258 148" stroke="#1a0a00" strokeWidth="5.5" strokeLinecap="round" fill="none"/>
    <circle cx="148" cy="190" r="29" fill="#111"/>
    <circle cx="148" cy="190" r="21" fill="#222"/>
    <path d="M148 172 L151 182 L162 182 L153 188 L156 198 L148 192 L140 198 L143 188 L134 182 L145 182 Z" fill="white" opacity="0.95"/>
    <circle cx="158" cy="198" r="3" fill="white" opacity="0.8"/>
    <circle cx="245" cy="190" r="29" fill="#111"/>
    <circle cx="245" cy="190" r="21" fill="#222"/>
    <path d="M245 172 L248 182 L259 182 L250 188 L253 198 L245 192 L237 198 L240 188 L231 182 L242 182 Z" fill="white" opacity="0.95"/>
    <circle cx="255" cy="198" r="3" fill="white" opacity="0.8"/>
  </>
);

const EyesWide = () => (
  <>
    <path d="M112 145 Q138 130 162 140" stroke="#1a0a00" strokeWidth="5.5" strokeLinecap="round" fill="none"/>
    <path d="M214 140 Q238 130 262 145" stroke="#1a0a00" strokeWidth="5.5" strokeLinecap="round" fill="none"/>
    <circle cx="148" cy="192" r="33" fill="#111"/>
    <circle cx="148" cy="192" r="24" fill="#222"/>
    <ellipse cx="136" cy="180" rx="8" ry="9" fill="white" opacity="0.95"/>
    <circle cx="160" cy="200" r="4" fill="white" opacity="0.8"/>
    <circle cx="248" cy="192" r="33" fill="#111"/>
    <circle cx="248" cy="192" r="24" fill="#222"/>
    <ellipse cx="236" cy="180" rx="8" ry="9" fill="white" opacity="0.95"/>
    <circle cx="260" cy="200" r="4" fill="white" opacity="0.8"/>
  </>
);

const EyesAngry = () => (
  <>
    <path d="M112 162 Q130 155 158 165" stroke="#1a0a00" strokeWidth="7" strokeLinecap="round" fill="none"/>
    <path d="M218 165 Q246 155 264 162" stroke="#1a0a00" strokeWidth="7" strokeLinecap="round" fill="none"/>
    <ellipse cx="148" cy="194" rx="27" ry="22" fill="#111"/>
    <path d="M120 183 Q148 175 176 183" fill="#c06a28" opacity="0.7"/>
    <ellipse cx="148" cy="194" rx="19" ry="16" fill="#222"/>
    <ellipse cx="138" cy="186" rx="6" ry="7" fill="white" opacity="0.85"/>
    <ellipse cx="246" cy="194" rx="27" ry="22" fill="#111"/>
    <path d="M218 183 Q246 175 274 183" fill="#c06a28" opacity="0.7"/>
    <ellipse cx="246" cy="194" rx="19" ry="16" fill="#222"/>
    <ellipse cx="236" cy="186" rx="6" ry="7" fill="white" opacity="0.85"/>
  </>
);

const EyesHalf = () => (
  <>
    <path d="M120 168 Q138 165 158 168" stroke="#1a0a00" strokeWidth="5" strokeLinecap="round" fill="none"/>
    <path d="M218 168 Q238 165 256 168" stroke="#1a0a00" strokeWidth="5" strokeLinecap="round" fill="none"/>
    <circle cx="148" cy="193" r="26" fill="#111"/>
    <path d="M122 193 Q148 178 174 193 L174 175 Q148 162 122 175 Z" fill="#D4732A"/>
    <circle cx="148" cy="196" r="17" fill="#222"/>
    <ellipse cx="140" cy="190" rx="5" ry="6" fill="white" opacity="0.8"/>
    <circle cx="246" cy="193" r="26" fill="#111"/>
    <path d="M220 193 Q246 178 272 193 L272 175 Q246 162 220 175 Z" fill="#D4732A"/>
    <circle cx="246" cy="196" r="17" fill="#222"/>
    <ellipse cx="238" cy="190" rx="5" ry="6" fill="white" opacity="0.8"/>
  </>
);

const EyesClosed = () => (
  <>
    <path d="M118 162 Q138 154 158 159" stroke="#1a0a00" strokeWidth="5.5" strokeLinecap="round" fill="none"/>
    <path d="M218 159 Q238 154 255 162" stroke="#1a0a00" strokeWidth="5.5" strokeLinecap="round" fill="none"/>
    <ellipse cx="148" cy="192" rx="26" ry="8" fill="#D4732A"/>
    <path d="M122 192 Q148 206 174 192" stroke="#1a0a00" strokeWidth="4" strokeLinecap="round" fill="none"/>
    <ellipse cx="246" cy="192" rx="26" ry="8" fill="#D4732A"/>
    <path d="M220 192 Q246 206 272 192" stroke="#1a0a00" strokeWidth="4" strokeLinecap="round" fill="none"/>
  </>
);

const EyesSide = () => (
  <>
    <path d="M116 162 Q135 157 158 163" stroke="#1a0a00" strokeWidth="5.5" strokeLinecap="round" fill="none"/>
    <path d="M218 160 Q240 155 260 162" stroke="#1a0a00" strokeWidth="5.5" strokeLinecap="round" fill="none"/>
    <circle cx="148" cy="190" r="27" fill="#111"/>
    <circle cx="155" cy="190" r="19" fill="#222"/>
    <ellipse cx="148" cy="181" rx="6" ry="7" fill="white" opacity="0.9"/>
    <circle cx="162" cy="197" r="3" fill="white" opacity="0.75"/>
    <circle cx="246" cy="190" r="27" fill="#111"/>
    <circle cx="253" cy="190" r="19" fill="#222"/>
    <ellipse cx="246" cy="181" rx="6" ry="7" fill="white" opacity="0.9"/>
    <circle cx="260" cy="197" r="3" fill="white" opacity="0.75"/>
  </>
);

const EYES_COMPONENTS: Record<EyesKey, React.FC> = {
  open: EyesOpen,
  happy: EyesHappy,
  wide: EyesWide,
  angry: EyesAngry,
  half: EyesHalf,
  closed: EyesClosed,
  side: EyesSide,
};

const BuddySvgEyes = React.memo(function BuddySvgEyes({ variant }: Props) {
  const EyeComponent = EYES_COMPONENTS[variant];
  return <EyeComponent />;
});

export default BuddySvgEyes;
